import { BaseSerializer } from './base.serializer'
import { HubStop } from 'models/hub-stop.model'
import { DateSerializer, TimeSerializer } from './attributes'

export class HubStopSerializer extends BaseSerializer<HubStop> {
  static SERIALIZABLE_ATTRIBUTES = [
     'id', 'hubId', 'from', 'to', 'sms', 'smsText'
  ]

  static SERIALIZERS = { from: TimeSerializer, to: TimeSerializer }
  static SERIALIZE_RENAME_KEYS = {}


  static DESERIALIZERS = {
    createdAt: TimeSerializer,
    from: TimeSerializer,
    to: TimeSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}


  static initializeObject(attributes: Object): HubStop {
    return new HubStop(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/hub-stop.serializer.ts